<template>
  <v-dialog v-model="dialogOpen" width="600" persistent>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined style="margin-right:1em">
        <v-icon left>fal fa-envelope</v-icon>
        Email List
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Send Email
        <v-spacer></v-spacer>
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">Template<v-icon right>fal fa-chevron-down</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-dialog v-model="templateNameDialog" width="400">
              <template v-slot:activator="{ on }">
                <v-list-item v-on="on" :disabled="!formValid">
                  <v-list-item-title>Save New Template</v-list-item-title>
                </v-list-item>
              </template>
              <v-card>
                <v-card-title class="headline" primary-title>Name this email template</v-card-title>
                <v-card-text>
                  <v-text-field v-model="templateName" label="Template Name"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="templateNameDialog=false">Cancel</v-btn>
                  <v-btn text color="success" @click="createTemplate">Create Template</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="templateSelectDialog" width="500">
              <template v-slot:activator="{ on }">
                <v-list-item v-on="on">
                  <v-list-item-title>Load Template</v-list-item-title>
                </v-list-item>
              </template>
              <v-card>
                <v-card-title class="headline" primary-title>Select a template to load</v-card-title>
                <v-card-text>
                  <template-list @select="loadTemplate"></template-list>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="templateSelectDialog=false">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-list-item :disabled="!formValid || selectedTemplate==null" @click="updateTemplate()">
              <v-list-item-title>Update Template</v-list-item-title>
            </v-list-item>
            <v-list-item to="/admin/tracker/email-template">
              <v-list-item-title>Manage Templates</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <p>All emails will be sent from the studentdevelopment@covenant.edu account, and will be sent to the student's Covenant and Home email addresses.</p>
        <v-text-field v-model="subject" label="Subject"></v-text-field>
        <editor v-model="body" :mergeFields="mergeFields"></editor>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="dialogOpen = false">Cancel</v-btn>
        <v-btn text color="success" @click="send()" :disabled="!formValid">Send</v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn tile icon v-on="on" :disabled="!formValid">
              <v-icon>fas fa-caret-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="send()">
              <v-list-item-title>Send Now</v-list-item-title>
            </v-list-item>
            <v-list-item @click="scheduleDialog = true">
              <v-list-item-title>Schedule to Send Later</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="clearForm" :disabled="formEmpty">Clear Form</v-btn>
      </v-card-actions>
    </v-card>
    <schedule :dialog-open="scheduleDialog" @close="scheduleDialog = false" @save="send"></schedule>
  </v-dialog>
</template>
<script>
import { ref, computed } from '@vue/composition-api'

export default {
  components: {
    TemplateList: () => import('./email/templateList'),
    Editor: () => import('@/components/forms/HTMLEditor'),
    Schedule: () => import('./schedule')
  },
  setup (props, { root, emit }) {
    const dialogOpen = ref(false)
    const subject = ref('')
    const body = ref('')
    const templateNameDialog = ref(false)
    const templateName = ref('')
    const templateSelectDialog = ref(false)
    const selectedTemplate = ref(null)
    const scheduleDialog = ref(false)

    const mergeFields = ref([
      'FirstName',
      'LastName',
      'BannerId',
      'Email',
      'SectionsLeft',
      'SectionsComplete'
    ])
    const formValid = computed(() => subject.value !== '' && body.value !== '')
    const formEmpty = computed(() => subject.value === '' && body.value === '')

    async function send (scheduledDate) {
      let obj = {
        runDate: scheduledDate || new Date(),
        status: scheduledDate ? 'Scheduled' : 'Queued',
        subject: subject.value,
        body: body.value,
        filters: root.$store.state.admin.filters
      }
      let data = await root.$feathers.service('orientation/email-log').create(obj)
      root.$store.dispatch('snackbar', {
        color: 'success',
        text: 'Email added to queue',
        actionText: 'Go to queue',
        action: 'to:/admin/tracker/email-log/' + data._id,
        timeout: 6000,
        active: true
      })

      dialogOpen.value = false
    }

    async function createTemplate () {
      let obj = {
        title: templateName.value,
        subject: subject.value,
        body: body.value
      }
      try {
        let data = await root.$feathers.service('system/email-template').create(obj)
        selectedTemplate.value = data._id
        root.$store.dispatch('snackbar', { color: 'success', text: 'Template created successfully', timeout: 6000, active: true })
        templateNameDialog.value = false
      } catch (text) {
        root.$store.dispatch('snackbar', { color: 'error', text, timeout: 6000, active: true })
      }
    }

    async function updateTemplate () {
      try {
        let data = await root.$feathers.service('system/email-template').patch(selectedTemplate.value, { subject: subject.value, body: body.value })
        selectedTemplate.value = data._id
        root.$store.dispatch('snackbar', { color: 'success', text: 'Template updated successfully', timeout: 6000, active: true })
        templateNameDialog.value = false
      } catch (text) {
        root.$store.dispatch('snackbar', { color: 'error', text, timeout: 6000, active: true })
      }
    }

    function loadTemplate (item) {
      selectedTemplate.value = item._id
      subject.value = item.subject
      body.value = item.body
      templateSelectDialog.value = false
    }

    function clearForm () {
      subject.value = ''
      body.value = ''
      selectedTemplate.value = null
    }

    return {
      dialogOpen,
      subject,
      body,
      templateNameDialog,
      templateName,
      templateSelectDialog,
      selectedTemplate,
      scheduleDialog,
      mergeFields,
      formValid,
      formEmpty,
      send,
      createTemplate,
      updateTemplate,
      loadTemplate,
      clearForm
    }
  }
}
</script>
